import { FC } from 'react';
import { Menu } from 'antd';
import FieldResourcesIcon from 'app/containers/Task/icons/FieldResourcesIcon';
import { useTranslation } from 'react-i18next';
import { GarageTabKeyType } from '../../types';
import { RouteConstants } from 'app/routes';
import { generatePath, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';

interface IProps {
  selectedKey?: string;
}

const GarageTabs: FC<IProps> = ({ selectedKey }) => {
  const { t } = useTranslation();
  const envId = useSelector(selectSelectedEnvId);
  const history = useHistory();

  const onMenuClick = (clickedKey: string, route: string) => {
    if (clickedKey === selectedKey) {
      return;
    }

    history.push(route);
  };

  const menuItems: {
    title: string;
    icon: JSX.Element;
    key: GarageTabKeyType;
    route: string;
  }[] = [
    {
      title: t('Garage.Tabs.Transport', 'Transport'),
      icon: <FieldResourcesIcon />,
      key: 'transport',
      route: generatePath(RouteConstants.garage.transportList, {
        envId: envId as number,
      }),
    },
    {
      title: t('Garage.Tabs.Accessories', 'Accessories'),
      icon: <FieldResourcesIcon />,
      key: 'implement',
      route: generatePath(RouteConstants.garage.implementList, {
        envId: envId as number,
      }),
    },
    {
      title: t('Garage.Tabs.Workers', 'Workers'),
      icon: <FieldResourcesIcon />,
      key: 'employee',
      route: generatePath(RouteConstants.garage.employeeList, {
        envId: envId as number,
      }),
    },
  ];

  const selectedKeysArr = selectedKey ? [selectedKey] : undefined;

  return (
    <Menu mode="inline" selectedKeys={selectedKeysArr}>
      {menuItems.map(item => (
        <Menu.Item
          icon={item.icon}
          key={item.key}
          onClick={() => onMenuClick(item.key, item.route)}
        >
          {item.title}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default GarageTabs;
